import { useCallback, useEffect, useRef, useState } from "react";

export default function useMeetingsRefresh(fetchMeetings, userId) {
  const fetchRef = useRef(fetchMeetings);
  const refreshRef = useRef(() => {});
  const [refreshing, setRefreshing] = useState(false);
  const [refreshError, setRefreshError] = useState("");
  useEffect(() => { fetchRef.current = fetchMeetings; });

  useEffect(() => {
    let active = true;
    let pending = false;
    let controller;
    const refresh = async () => {
      if (!active || pending) return;
      pending = true;
      controller = new AbortController();
      setRefreshing(true);
      setRefreshError("");
      try {
        await fetchRef.current(controller.signal);
      } catch (error) {
        if (active && !controller.signal.aborted) {
          setRefreshError("Unable to refresh meetings. Please try again.");
        }
      } finally {
        pending = false;
        if (active) setRefreshing(false);
      }
    };
    refreshRef.current = refresh;
    refresh();
    const timer = setInterval(refresh, 30000);
    return () => {
      active = false;
      clearInterval(timer);
      controller?.abort();
      refreshRef.current = () => {};
    };
  }, [userId]);

  const refreshMeetings = useCallback(() => refreshRef.current(), []);
  return { refreshMeetings, refreshing, refreshError };
}
